import * as React from 'react';
import * as styles from './Distance.css';
import { IconCar16 } from '@cian/ui-kit';
import { IGeoRoadInfoSchema } from '../../../../../../../shared/repositories/newbuilding-card/entities/geo/GeoRoadInfoSchema';

interface IDistanceProps {
  roads?: IGeoRoadInfoSchema[] | null;
}

export const Distance: React.FC<IDistanceProps> = props => {
  const { roads } = props;

  if (!(roads && roads.length)) {
    return null;
  }

  return (
    <>
      {roads
        .filter(road => road.distance)
        .map(roadItem => (
          <div className={styles['distance']} key={`${roadItem.name}`}>
            <div className={styles['distance-icon']}>
              <IconCar16 color={'gray_icons_100'} />
            </div>
            <span className={styles['distance-text']}>{`${roadItem.name}, ${roadItem.distance} км от МКАД`}</span>
          </div>
        ))}
    </>
  );
};
